/**
 * @generated SignedSource<<be314aa097f9f4bfc957a499a362571c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedEmptyDesignsBannerWrapper_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedEmptyDesignsBanner_itemSearch">;
  readonly " $fragmentType": "SbSharedEmptyDesignsBannerWrapper_itemSearch";
};
export type SbSharedEmptyDesignsBannerWrapper_itemSearch$key = {
  readonly " $data"?: SbSharedEmptyDesignsBannerWrapper_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedEmptyDesignsBannerWrapper_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedEmptyDesignsBannerWrapper_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedEmptyDesignsBanner_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "fd5454d78798ecf5e3da9b4385f73658";

export default node;
